import React, {Component} from 'react'
import {compose} from 'recompose'
import withSelectFetch from './withSelectFetch'
import withSpinning from '../HOC/withSpinning'
import CustomSelect from './CustomSelect'
import withSort from '../HOC/withSort'

function Country(props) {
  return (
    <CustomSelect
      placeholder={'Select a country'}
      {...props}
      keyAtr={'value'}
      valueAtr={'value'}
    />
  )
}

const CountrySelect = compose(
  withSelectFetch({dropdown: 'general', name: 'country'}),
  withSpinning,
  withSort,
)(Country)

export default CountrySelect
